<template>
  <div>
    <el-form :model="employeeForm" :rules="formRules" label-position="right" ref="employeeForm" label-width="90px" class="demo-ruleForm">
      <el-row>
        <el-col :span="12">
          <el-form-item label="所属部门" prop="employeeDepartment">
            <el-input ref="employeeCode" v-model="employeeForm.employeeDepartment" style="width: 98%" placeholder="输入所属部门"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="人员工号" prop="employeeCode">
            <el-input ref="employeeCode" v-model="employeeForm.employeeCode" style="width: 98%" placeholder="输入人员工号"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="人员姓名" prop="employeeName">
            <el-input ref="employeeName" v-model="employeeForm.employeeName" style="width: 98%" placeholder="输入人员姓名"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="人员性别" prop="employeeSex">
            <el-radio v-model="employeeForm.employeeSex" label="男">男</el-radio>
            <el-radio v-model="employeeForm.employeeSex" label="女">女</el-radio>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="出生日期" prop="employeeBirthDay">
            <el-date-picker v-model="employeeForm.employeeBirthDay" style="width: 98%" type="date" placeholder="选择出生日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="身份证号" prop="employeeIDCard">
            <el-input v-model="employeeForm.employeeIDCard" style="width: 98%" placeholder="请输入身份证号"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="入职日期" prop="serviceDate">
            <el-date-picker v-model="employeeForm.serviceDate" style="width: 98%" type="date" placeholder="选择入职日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话" prop="employeeTel">
            <el-input v-model="employeeForm.employeeTel" style="width: 98%" placeholder="请输入联系电话"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="学　　历" prop="employeeEducation">
            <el-input v-model="employeeForm.employeeEducation" style="width: 98%" placeholder="请输入学历"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="毕业学校" prop="employeeSchool">
            <el-input v-model="employeeForm.employeeSchool" style="width: 98%" placeholder="请输入毕业学校"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="职　　称" prop="employeeDuty">
            <el-input v-model="employeeForm.employeeDuty" style="width: 98%" placeholder="请输入职称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="职　　务 " prop="employeeJob">
            <el-input v-model="employeeForm.employeeJob" style="width: 98%" placeholder="请输入职务"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-upload class="upload-demo" action="#" :before-remove="handleBeforeRemove" :on-remove="handleRemove" :on-progress="handProgress" :on-preview="handPreview" :limit="1"
                 :http-request="uploadFile" :on-exceed="handExceed" :file-list="fileList">
        <el-button size="small" type="primary">电子签字</el-button>
        <div slot="tip" class="el-upload__tip">{{tipText}}</div>
      </el-upload>
      <el-upload class="upload-demo" action="#" :before-remove="handleCertBeforeRemove" :on-remove="handleCertRemove" :on-progress="handCertProgress" :on-preview="handCertPreview" :limit="1"
                 :http-request="uploadCertFile" :on-exceed="handCertExceed" :file-list="certFileList">
        <el-button size="small" type="primary">人员证书</el-button>
        <div slot="tip" class="el-upload__tip">{{certTipText}}</div>
      </el-upload>
    </el-form>
    <div style="text-align: center">
      <el-button type="primary" style="width: 120px" :disabled="saveButState" @click="submitForm()" v-html="saveButValue"></el-button>
      <el-button type="danger" style="width: 120px" @click="closeWindow()">关 闭</el-button>
    </div>
    <el-dialog title="文件预览" size="55%" :visible.sync="isview" append-to-body>
      <PdfImgViewer ref="pdfImgViewer" :fileName="viewFileName"></PdfImgViewer>
    </el-dialog>
  </div>
</template>
<script>
import PdfImgViewer from "@/components/pdfview/PdfImgViewer.vue";
import { appjs } from "@/utiljs/apputil";
export default {
  components: {
    PdfImgViewer
  },
  props: {
    closeWindow: {
      type: Function
    }
  },
  data () {
    return {
      isview: false,
      saveButValue: '保 存',
      tipText: '只能上传jpg/png文件，且不超过500kb',
      certTipText: '支持上传pdf/doc/docx等文件格式',
      saveButState: false,
      innerVisible: false,
      viewFileName: '',
      tableData: [],
      tableHeight: '280px',
      fileList: [],
      certFileList: [],
      employeeForm: {
        employeeDepartment: '',
        employeeCode: '',
        employeeName: '',
        employeeSex: '男',
        employeeIDCard: '',
        serviceDate: '',
        employeeBirthDay: '',
        employeeEducation: '',
        employeeSchool: '',
        employeeDuty: '',
        employeeJob: '',
        employeeTel: '',
        signImgUUID: '',
        certificateImgUUID: ''
      },
      formRules: {
        employeeCode: [
          { required: true, message: '请输入人员工号', trigger: 'blur' }
        ],
        employeeName: [
          { required: true, message: '请输入人员姓名', trigger: 'blur' }
        ],
        employeeDepartment: [
          { required: true, message: '请输入所属部门', trigger: 'blur' }
        ],
      }
    }
  },
  created () {
    this.resertForm();
  },
  methods: {
    resertForm () {
      this.saveButValue = '保 存';
      this.saveButState = false;
      this.$refs['employeeForm'].resetFields();
      this.fileList = [];
      this.certFileList = [];
    },
    handleBeforeRemove (file) {
      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        this.handleRemove(file);
      })
      return false;
    },
    handleRemove (file) {
      var idx = -1;
      for (var i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].fileUUID == file.fileUUID) {
          idx = i;
        }
      }
      if (idx != -1) {
        this.fileList.splice(idx, 1);
      }
    },
    handPreview (file) {
      this.viewFileName = file.fileUUID;
      this.isview = true;
      this.$nextTick(() => {
        if (this.$refs['pdfImgViewer']) {
          this.$refs['pdfImgViewer'].init();
        }
      });
    },
    handProgress (event, file, fileList) {
      console.log('上传进度', event.percent);
    },
    handExceed () {
      appjs.showWarningMsg("只能上传一个文件")
    },
    //上传文件
    uploadFile (fileData) {
      var _self = this;
      var formdata = new FormData();
      formdata.append("file", fileData.file);
      var name = fileData.file.name;
      var type = name.substring(name.lastIndexOf(".") + 1);
      formdata.append("fileType", type);
      appjs.httpRequest('fileupload', formdata, "fileupload", function (event) {
        _self.tipText = "文件上传中:" + ((event.loaded / event.total) * 100).toFixed(0) + "%";
      }).then((data) => {
        if (data.retCode && data.retCode != "ok") {
          fileData.onError();
          appjs.showErrorMsg(data.retMsg);
        } else {
          fileData.onSuccess();
          this.fileList.push({ fileUUID: data.retMsg, fileName: name, name: name });
          _self.tipText = '上传完成！';
          appjs.showSuccessMsg("上传成功");
        }
      }).catch((error) => {
        appjs.showErrorMsg("异常：" + error)
      })
    },
    handleCertBeforeRemove (file) {
      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        this.handleCertRemove(file);
      })
      return false;
    },
    handleCertRemove (file) {
      var idx = -1;
      for (var i = 0; i < this.certFileList.length; i++) {
        if (this.certFileList[i].fileUUID == file.fileUUID) {
          idx = i;
        }
      }
      if (idx != -1) {
        this.certFileList.splice(idx, 1);
      }
    },
    handCertPreview (file) {
      this.viewFileName = file.fileUUID;
      this.isview = true;
      this.$nextTick(() => {
        if (this.$refs['pdfImgViewer']) {
          this.$refs['pdfImgViewer'].init();
        }
      });
    },
    handCertProgress (event, file, fileList) {
      console.log('证书上传进度', event.percent);
    },
    handCertExceed () {
      appjs.showWarningMsg("只能上传一个证书文件")
    },
    //上传证书文件
    uploadCertFile (fileData) {
      var _self = this;
      var formdata = new FormData();
      formdata.append("file", fileData.file);
      var name = fileData.file.name;
      var type = name.substring(name.lastIndexOf(".") + 1);
      formdata.append("fileType", type);
      appjs.httpRequest('fileupload', formdata, "fileupload", function (event) {
        _self.certTipText = "文件上传中:" + ((event.loaded / event.total) * 100).toFixed(0) + "%";
      }).then((data) => {
        if (data.retCode && data.retCode != "ok") {
          fileData.onError();
          appjs.showErrorMsg(data.retMsg);
        } else {
          fileData.onSuccess();
          this.certFileList.push({ fileUUID: data.retMsg, fileName: name, name: name });
          _self.certTipText = '上传完成！';
          appjs.showSuccessMsg("上传成功");
        }
      }).catch((error) => {
        appjs.showErrorMsg("异常：" + error)
      })
    },
    submitForm () {
      this.$refs['employeeForm'].validate((valid) => {
        if (valid) {
          let params = this.employeeForm;
          if (this.fileList.length > 0) {
            params.signImgUUID = this.fileList[0].fileUUID;
          }
          if (this.certFileList.length > 0) {
            params.certificateImgUUID = this.certFileList[0].fileUUID;
          }
          this.saveButValue = '保存中....'
          this.saveButState = true;
          let _self = this;
          appjs.httpRequest('employee/saveEmployee', params).then((data) => {
            if (data.retCode && data.retCode != "ok") {
              appjs.showErrorMsg(data.retMsg);
              _self.saveButValue = '保存';
              _self.saveButState = false;
            } else {
              _self.saveButValue = '保存成功';
              _self.closeWindow(data.retMsg);
            }
          }).catch((error) => {
            _self.saveButState = false;
            _self.loginText = '保存';
            appjs.showErrorMsg("异常：" + error)
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
}
</script>
